const LocationLookupFixture = [
  {
    field: "locationName",
    title: "Store Name",
    border: true,
    filter: false,
    show: true,
    min_width: 20,
  },
  {
    field: "locationId",
    title: "Store Number",
    border: true,
    filter: false,
    show: true,
    min_width: 20,
  },
  {
    field: "locationManager",
    title: "Manager",
    border: true,
    filter: false,
    show: true,
    min_width: 15,
  },

  {
    field: "isActive",
    title: "Status",
    editable: false,
    editor: "text",
    switchCell: true,
    cell: true,
    border: true,
    filter: true,
    show: true,
    min_width: 15,
    filterType: "boolean",
    customFilter: true,
    filterData: [
      { tab: "Active", value: true },
      { tab: "Inactive", value: false },
    ],
    primary: true,
  },
  {
    field: "locationAddress.city",
    title: "City",
    border: true,
    filter: false,
    show: true,
    min_width: 20,
  },
  {
    field: "locationAddress.region",
    title: "State",
    border: true,
    filter: false,
    show: true,
    min_width: 15,
  },

  {
    field: "phoneNumber.number",
    title: "Phone",
    filter: false,
    show: true,
    min_width: 15,
  },
  {
    field: "locationSupportEmail",
    title: "Email",
    border: true,
    filter: false,
    show: true,
    min_width: 15,
  },
]
export default LocationLookupFixture
